const trimTrailingSlash = function(path) {
  if (path.charAt(path.length - 1) === '/') {
    return path.substring(0, path.length - 1);
  } else {
    return path;
  }
};
export default trimTrailingSlash;
